import { motion } from "framer-motion";

export const AligneursDetail = () => {
  return (
    <section
      id="specialites"
      data-testid="aligneurs-detail-section"
      className="py-20 md:py-32 bg-[#F3EBE3]/50 relative overflow-hidden"
    >
      <div className="container-xl">
        {/* Section header */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-16 md:mb-20"
        >
          <span className="overline">Nos Spécialités</span>
          <h2 className="h2 text-4xl sm:text-5xl lg:text-6xl mt-5">
            Deux expertises,{" "}
            <span className="italic text-[#BE6C42]">une même exigence.</span>
          </h2>
          <p className="body-text text-base sm:text-lg mt-6">
            Des domaines d&apos;excellence où nos praticiens ont développé un
            savoir-faire reconnu.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left — Image collage */}
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="grid grid-cols-6 gap-4">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="col-span-4 aspect-[3/4] rounded-2xl overflow-hidden relative group"
                data-testid="aligneurs-photo-main"
              >
                <img
                  src="https://customer-assets.emergentagent.com/job_smile-lagavotte/artifacts/ixzj1of5_PSTK4499.JPG"
                  alt="Aligneurs invisibles — démonstration"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2D241E]/20 via-transparent to-transparent" />
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{
                  duration: 0.8,
                  delay: 0.15,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="col-span-2 flex flex-col gap-4"
              >
                <div
                  className="aspect-square rounded-2xl overflow-hidden relative group"
                  data-testid="aligneurs-photo-ai-1"
                >
                  <img
                    src="/treatments/aligneur-1.png"
                    alt="Aligneur invisible tenu entre les doigts"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div
                  className="flex-1 min-h-[140px] rounded-2xl overflow-hidden relative group"
                  data-testid="aligneurs-photo-ai-2"
                >
                  <img
                    src="/treatments/aligneur-2.png"
                    alt="Série d'aligneurs transparents"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              </motion.div>
            </div>
          </div>

          {/* Right — Text */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-6 order-1 lg:order-2"
          >
            <div
              className="inline-flex items-center gap-2.5 bg-[#BE6C42] text-white rounded-full px-4 py-2"
              data-testid="aligneurs-specialty-badge"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-white" />
              <span className="text-[11px] uppercase tracking-[0.22em] font-semibold">
                Notre spécialité
              </span>
            </div>
            <h2 className="h2 text-3xl sm:text-4xl lg:text-5xl mt-6 leading-[1.05]">
              Les aligneurs invisibles,
              <br />
              <span className="italic text-[#BE6C42] font-light">
                c&apos;est quoi ?
              </span>
            </h2>

            <p className="body-text text-base sm:text-lg mt-8">
              Ce sont des gouttières transparentes, réalisées{" "}
              <span className="text-[#2D241E] font-medium">sur mesure</span>,
              qui permettent de déplacer progressivement les dents pour les
              réaligner.
            </p>

            <div className="mt-6 pl-6 border-l-2 border-[#BE6C42]">
              <p className="body-text text-base sm:text-lg">
                Une solution{" "}
                <span className="text-[#2D241E] font-medium">discrète</span>,{" "}
                <span className="text-[#2D241E] font-medium">confortable</span>{" "}
                et adaptée à votre quotidien.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
              {[
                { k: "100%", v: "Sur-mesure" },
                { k: "∞", v: "Amovible" },
                { k: "0", v: "Contrainte visible" },
              ].map((stat) => (
                <div
                  key={stat.v}
                  className="border-t border-[#E8DED5] pt-4"
                  data-testid={`aligneurs-stat-${stat.v.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <div className="font-serif text-3xl text-[#BE6C42] italic leading-none">
                    {stat.k}
                  </div>
                  <div className="mt-2 text-xs text-[#6A584E] leading-snug">
                    {stat.v}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AligneursDetail;
